export default "__VITE_ASSET__T6xioR0K__"